var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { observer } from 'mobx-react';
import { List, ListHeading, ListItems, ListItemEmpty, HeadingDivider, DotsHorizontal, ItemEmptyIconWrapper, } from './components';
// import {GenericListBoardCollection, ListBoardPropsList, ListBoardPropsRender} from "./types";
import { ListBoardItemV2 } from './item';
import styled from 'styled-components';
import { CommonText } from '../bumpViews/commonText';
import { SORT_TYPES } from './constants';
import { OrderStatusEmptyIcon } from '../bumpViews/card/card-icon';
const MultiSelectionWrapper = styled.div `
  background: #fefefe;
  border-radius: 4px;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.15);
  padding: 12px;
  display: flex;
  width: 279px;
  padding: 12px;
  flex-direction: column;
  align-items: flex-start;
  position: absolute;
  // top: 32px;
  margin-top: -16px;
  z-index: 1;
`;
const SelectionItemWrapper = styled.div `
  display: flex;
  padding: 8px 0px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  cursor: pointer;
`;
let ListBoardListV2 = class ListBoardListV2 extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectionDropdownActive: false,
            showCheckbox: false,
            oldToNewSort: true,
        };
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.showBottomBar !== this.props.showBottomBar && !this.props.showBottomBar) {
            this.setState({ showCheckbox: false });
        }
    }
    addZero(number) {
        let numberString = String(number);
        if (numberString.length === 1) {
            numberString = '0' + numberString;
        }
        return numberString;
    }
    render() {
        const { list, data, renderIcon, renderRow, renderRowDropdown, renderBottom, toggleBottomBar, selectedOrders, setSelectedOrders, setStatus, columnSelecting } = this.props;
        const { selectionDropdownActive, showCheckbox, oldToNewSort } = this.state;
        if (list.hide)
            return null;
        let items = [];
        if (data.lists[list.id]) {
            const tempItems = data.lists[list.id].items || [];
            items = oldToNewSort ? tempItems.slice().sort((a, b) => a.updated - b.updated) : tempItems.slice().sort((a, b) => b.updated - a.updated);
        }
        if (list.hideIfEmpty && items.length === 0)
            return null;
        const handleOpenSelectDropdown = () => {
            setStatus(list.id);
            this.setState({
                selectionDropdownActive: !selectionDropdownActive,
                showCheckbox: false,
            });
            toggleBottomBar(false);
        };
        const handleSelect = () => {
            columnSelecting(items);
            this.setState({
                selectionDropdownActive: false,
                showCheckbox: true,
            });
            setSelectedOrders([]);
            toggleBottomBar(true);
        };
        const handleSelectAll = () => {
            const allIds = items.map(item => item._id);
            columnSelecting(items);
            setSelectedOrders(allIds);
            this.setState({
                selectionDropdownActive: false,
                showCheckbox: true,
            });
            toggleBottomBar(true);
        };
        const handleSort = (type) => {
            if (type === SORT_TYPES.OLD_TO_NEW) {
                this.setState({
                    oldToNewSort: true,
                });
            }
            if (type === SORT_TYPES.NEW_TO_OLD) {
                this.setState({
                    oldToNewSort: false,
                });
            }
            this.setState({
                selectionDropdownActive: false,
            });
        };
        return (React.createElement(React.Fragment, null,
            React.createElement(ListHeading, { color: list.color },
                React.createElement("div", null,
                    list.title,
                    React.createElement(HeadingDivider, null, "-"),
                    this.addZero(items.length)),
                items.length > 0 && React.createElement(DotsHorizontal, { onClick: handleOpenSelectDropdown })),
            selectionDropdownActive && items.length > 0 && (React.createElement(MultiSelectionWrapper, null,
                React.createElement(SelectionItemWrapper, { onClick: handleSelect },
                    React.createElement(CommonText, { size: "semiMedium", weight: 400, color: "#4B4F5E" }, "Select")),
                React.createElement(SelectionItemWrapper, { onClick: handleSelectAll },
                    React.createElement(CommonText, { size: "semiMedium", weight: 400, color: "#4B4F5E" }, "Select All")),
                React.createElement(SelectionItemWrapper, { onClick: () => handleSort(SORT_TYPES.OLD_TO_NEW) },
                    React.createElement(CommonText, { size: "semiMedium", weight: 400, color: "#4B4F5E" }, "Sort from old to new")),
                React.createElement(SelectionItemWrapper, { onClick: () => handleSort(SORT_TYPES.NEW_TO_OLD) },
                    React.createElement(CommonText, { size: "semiMedium", weight: 400, color: "#4B4F5E" }, "Sort from new to old")))),
            React.createElement(List, null,
                React.createElement(ListItems, null,
                    items.map((item, z) => (React.createElement(ListBoardItemV2, { key: z, list: list, item: item, renderIcon: renderIcon, renderRow: renderRow, renderRowDropdown: renderRowDropdown, renderBottom: renderBottom, showCheckbox: showCheckbox, selectedOrders: selectedOrders, setSelectedOrders: setSelectedOrders }))),
                    items.length === 0 && (React.createElement(ListItemEmpty, null,
                        React.createElement(ItemEmptyIconWrapper, null,
                            React.createElement(OrderStatusEmptyIcon, null)),
                        React.createElement("div", null, "Order status empty")))))));
    }
};
ListBoardListV2 = __decorate([
    observer
], ListBoardListV2);
export { ListBoardListV2 };
//# sourceMappingURL=list.js.map